import React, {useEffect, useState} from "react";
import classes from "../DataProvisionning.module.css";
import {FileUpload} from "primereact/fileupload";
import Aux from "../../../../../../hoc/Auxiliary";
import {isAuthorized} from "../../../../../../api/authorization/authorization-service";
import {Button} from "primereact/button";
import {isClosed} from "../../../../../../api/dataCollection/dataCollection-status";

const Header = () => {
    return (
        <div className="col-12 flex align-items-center justify-content-center">
                <span>
                    <label className={classes.title}>Data provisioning</label>
                </span>
        </div>
    )
}

const FileUploadButton = ({
                              isMandatoryData,
                              fileUploadRef,
                              getFileContext,
                              dataCollection,
                              statusLV4,
                              uploadBtnDisabled,
                              updateStatus,
                              isAutorizedTag,
                              uploadMethod
                          }) => {

    const [btnDisabled, setBtnDisabled] = useState(true)

    useEffect(() => {
        if (isClosed(dataCollection.status)) {
            if (isAuthorized("AR38")) setBtnDisabled(false)
            else setBtnDisabled(true)
        } else if ((isAutorizedTag || isAuthorized("AR08")) && !statusLV4 && !uploadBtnDisabled) {
            setBtnDisabled(false)
        } else setBtnDisabled(true)
    }, [statusLV4, uploadBtnDisabled, isAutorizedTag, dataCollection.status]);

    return (
        <div className="col-12 flex align-items-center justify-content-center">
            <FileUpload mode="basic" name="demo[]"
                        ref={fileUploadRef}
                        accept={uploadMethod === "zip-xml" ? "application/zip" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,.ttl"}
                        className={classes.uploadBtn}
                        onSelect={getFileContext}
                        chooseLabel={"Upload data"}
                        disabled={btnDisabled}
            />
            {!isMandatoryData && (
                <Button
                    label="No data"
                    disabled={btnDisabled}
                    className={classes.noDataBtn}
                    icon="pi pi-times"
                    severity="secondary"
                    outlined
                    onClick={updateStatus}
                />
            )}

        </div>
    )
}
const UploadButton = ({
                          isMandatoryData,
                          fileUploadRef,
                          getFileContext,
                          dataCollection,
                          statusLV4,
                          uploadBtnDisabled,
                          updateStatus,
                          isAutorizedTag,
                          uploadMethod
                      }) => {
    return (
        <Aux>
            <div className="grid">
                <Header/>
                <FileUploadButton
                    isMandatoryData={isMandatoryData}
                    fileUploadRef={fileUploadRef}
                    getFileContext={getFileContext}
                    dataCollection={dataCollection}
                    statusLV4={statusLV4}
                    updateStatus={updateStatus}
                    uploadBtnDisabled={uploadBtnDisabled}
                    isAutorizedTag={isAutorizedTag}
                    uploadMethod={uploadMethod}

                />

                <div className="col-12 flex align-items-center justify-content-center mt-0 mb-0 pt-0 pb-0">
                    <span className="pi pi-info-circle pl-1"/>
                    <small
                        className={classes.small}>{uploadMethod === "zip-xml" ? 'Support ZIP files' : 'Support XLSX or TTL files'}</small>
                </div>
            </div>
        </Aux>
    )
}
export default UploadButton;
